import {
    PUSH_NOTIFICATION_TO_STACK,
    POP_NOTIFICATION_FROM_STACK,
    FLUSH_NOTIFICATION_FROM_STACK,
} from './constants';

const initialState = {};

const notificationReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case PUSH_NOTIFICATION_TO_STACK:
            return { ...state, ...payload };

        case POP_NOTIFICATION_FROM_STACK: {
            const prevState = { ...state };
            delete prevState[payload];
            return prevState;
        }

        case FLUSH_NOTIFICATION_FROM_STACK:
            return {};

        default:
            return state;
    }
};

export default notificationReducer;
